import Splide from '@splidejs/splide';

export default class SplideCarousel {

    static init() {
        const mainSlider = new Splide('#main-splide', {
            type: 'fade',
            fixedWidth: 780,
            pagination: false,
            arrows: false,
            breakpoints: {
                780: {
                    fixedWidth: 0
                },
            }
        }).mount();
        const thumbnailSlider = new Splide('#thumbnail-splide', {
            type: 'slide',
            rewind: true,
            gap: 8,
            perPage: 6,
            focus: 'center',
            fixedWidth: 140,
            pagination: false,
            arrows: false,
            isNavigation: true
        }).mount();
        mainSlider.sync(thumbnailSlider).mount();
        document.querySelector('.splide__arrow--next').addEventListener('click', () => {
            thumbnailSlider.go('>');
        });
        document.querySelector('.splide__arrow--prev').addEventListener('click', () => {
            thumbnailSlider.go('<');
        });
    }

}
